import { ThemeProvider } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import { themeGenerator } from "@commons/theme";
import { useAppSelector } from "@redux";
import "normalize.css";
import "@commons/theme/styles.css";

interface ITheme {
  children: React.ReactNode;
}
const Theme = ({ children }: ITheme) => {
  const { muiLocale, direction } = useAppSelector((S) => S.Locale);
  return (
    <StylesProvider>
      <ThemeProvider theme={themeGenerator(muiLocale, direction)}>
        {children}
      </ThemeProvider>
    </StylesProvider>
  );
};
export { Theme };
